import CartIcon from "@/assets/templates/icons/cartIcon";
import { useTemplateContext } from '@/context/TemplateProvider'

import Layout from "./views";

const MusicStore = () => {
  const { template } = useTemplateContext()
  return (
    <Layout.Container>
      <Layout.PreHeader>{template.sections.header?.title}</Layout.PreHeader>
      <Layout.Header textColor="textPrimary">
        <Layout.HeaderContent>
        <Layout.Logo>
            {template.logo.src ? (
              <Layout.LogoImage src={template.logo.src} />
            ) : (
              <Layout.LogoText fontFamily={template.logo.fontFamily}>
                {template.logo.text}
              </Layout.LogoText>
            )}
          </Layout.Logo>
          <Layout.Navigation textColor="textPrimary">
            <Layout.IconButton>
              <CartIcon />
            </Layout.IconButton>
          </Layout.Navigation>
        </Layout.HeaderContent>
      </Layout.Header>
      <Layout.Content textColor="textSecondary">
      <Layout.Img src={template.sections.hero.backgroundImage} />
      <Layout.ImgCover />
        <Layout.HeroTitle>{template.sections.hero.title}</Layout.HeroTitle>
        <Layout.CTA
          type="primary"
          textColor="textSecondary"
        >
        {template.sections.hero.ctaText}
        </Layout.CTA>
      </Layout.Content>
    </Layout.Container>
  );
};

export default MusicStore;
